import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import { Accordion } from 'react-bootstrap';
import Header from './../Layout/Header';
import Footer from './../Layout/Footer';

var img1 = require('./../../images/banner/bnr1.jpg');
var img2 = require('./../../images/background/bg5.jpg');

const defaultAccordion = [
	{ title: ' How can I contact you?', text: 'You can reach us by phone at +91 7358605115 or email us at cacofachocolates@gmail.com. Our shop is located at 2/70, Chelli Amman Kovil St, Puthur, ESIC Nagar, Tiruvanchery, thiruvencheri, Chennai, Tamil Nadu 600126.'  },
	{ title: ' Do you have any special offers?', text: 'We occasionally have special promotions and discounts. Follow us on Instagram (@cacofa_chocolates) to stay updated on our latest offers and new products.' },
	{ title: 'Do you offer delivery services?', text: 'Yes, we offer free delivery within a 5 km radius. For deliveries beyond that, there may be an additional charge depending on the distance.' },
	{ title: 'How far in advance should I place my order?', text: 'We recommend placing your order at least 2 days before the desired delivery date to ensure your cake is freshly baked and ready. Sometimes, we can accommodate last-minute orders depending on the cake.' },
	{ title: 'Can I customize my cake?', text: 'Yes, we offer customization for birthday and wedding cakes. You can provide us with a reference picture, and we ll create a cake that matches your vision. Please note that we do not use fondant.'},
	{ title: 'What types of cakes do you offer?', text: 'We offer a wide variety of cakes, including Dark Chocolate Cake, Butterscotch Cake, Vanilla Cake, Rose Pistachio Cake, Seasonal Fresh Fruit Cake, Black Forest Cake, Belgium 7 Layer Cake, and 7 Layer Dream Tin Cake.' },

]

const Faq = () => {	
	const [activeDefault, setActiveDefault] = useState(0)
	return(
		<>
			<Header />
			 <div className="page-content bg-white">
				<div className="dlab-bnr-inr overlay-black-middle" style={{backgroundImage:"url(" + img1 + ")", backgroundSize:"cover"}}>
					<div className="container">
						<div className="dlab-bnr-inr-entry">
							<h1 className="text-white">Faq's</h1>
							<div className="breadcrumb-row">
								<ul className="list-inline">
									<li><Link to={'./'}><i className="fa fa-home"></i></Link></li>
									<li>Faq's</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="content-block">
					<div className="section-full content-inner bg-white faq-area" style={{ backgroundImage:"url( " + img2 + " )", backgroundSize:"100%"}}>
						<div className="container">
							<div className="row">
								<div className="col-lg-4 col-md-5">
									<div className="m-b50">
										<div className="about-thumb">
											<img src={require('./../../images/about/pic4.jpg')} alt="" />
										</div>
									</div>
									{/* <div className="contact-form">
										<div className="title-bx">
											<div className="icon-bx-xs"> 
												<Link to={''} className="icon-cell text-white"><i className="fa fa-comment"></i></Link> 
											</div>
											<h4>Ask Us</h4>
										</div>
										<form>
											<div className="form-group">
												<label>Your Name (*)</label>
												<div className="input-group">
													<input name="dzName" type="text" required="" className="form-control" placeholder="" />
												</div>
											</div>
											<div className="form-group">
												<label>Your Email (*)</label>
												<div className="input-group">
													<input name="dzName" type="text" required="" className="form-control" placeholder="" />
												</div>
											</div>
											<div className="form-group">
												<label>Subject</label>
												<div className="input-group">
													<input name="dzName" type="text" required="" className="form-control" placeholder="" />
												</div>
											</div>
											<div className="form-group">
												<label>Select Service</label>
												<div className="input-group">
													<select className="form-control">
														<option>Cake </option>
														<option>Pastry</option>
														<option>Cookies</option>
													</select>
												</div>
											</div>
											<div className="form-group">
												<label>Your Question</label>
												<div className="input-group">
													<textarea className="form-control"></textarea>
												</div>
											</div>
											<div className="form-group">
												<button className="btn btn-md btnhover">Submit Now</button>
											</div>
										</form>
									</div> */}
								</div>
								<div className="col-lg-8 col-md-7 m-b30">
									<div className="faq-area2">
										<div className="row">
											<div className="col-lg-12">
												<div className="section-head text-left">
													<h3>Do You Have Any Questions?</h3>
													<p>Please read questions bellow and if you can not find your answer, please send us your question, we will answer you as soon as possible.</p>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-lg-12">
												<div className="title-bx">
													<div className="icon-bx-xs"> 
														<a href='tel:+917358605115' className="icon-cell text-white"><i className="fa fa-comment"></i></a> 
													</div>
													<h4>Ask Us</h4>
												</div>	
												<Accordion className="dlab-accordion faq-style2"  defaultActiveKey="0">
													{defaultAccordion.map((d, i) => (
													    <div className="panel">
															<div className="acod-head">
																<Accordion.Toggle as={Link} variant="link"
																	className={` ${ activeDefault === i ? '' : 'collapsed'}`}
																	onClick={() =>
																		setActiveDefault(activeDefault === i ? -1 : i)
																	} eventKey={`${i}`}>	
																	 {d.title}		
																</Accordion.Toggle>
															</div>
														<Accordion.Collapse eventKey={`${i}`} className="acod-body collapse ">
															<div className="acod-content">
																{d.text}
															</div>
														</Accordion.Collapse>
													  </div>
													))}
												</Accordion>
														
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>          
			<Footer />
		</>
	)
	
}

export default Faq;